import clsx from "clsx";
import React from "react";

interface ChipContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const ChipContainer = (props: ChipContainerProps) => {
  return <div {...props} className={clsx('flex justify-center flex-wrap gap-1', props.className)} />;
};
